export default __webpack_public_path__ + "static/adoption-banner-bg-58e5687234392419d7ef08995bf8945f.jpg";